export function createImmutableMap(entries) {
    const map = new Map(entries);
    return Object.freeze(map);
}
const nepFastlyProvider = 'NEP-FASTLY';
export const npoCdnProvidersData = [
    ['nep.global.ssl.fastly.net', nepFastlyProvider],
    ['npo-fsly.cdn.streamgate.io', nepFastlyProvider],
    ['npo-fsly-2.cdn.streamgate.io', nepFastlyProvider],
    ['cdn.streamgate.nl', 'NEP'],
    ['pr.lswcdn.net', 'NEP-LSW'],
    ['cdn.eurovisioncdn.net', 'EUROVISION'],
    ['npo.prd.cdn.bcms.kpn.com', 'KPN'],
    ['cdn.bcms.kpn.com', 'KPN'],
    ['Akamai', 'AKEMAI'],
    ['icecast.omroep.nl', 'OMROEP-ICECAST'],
    ['content.omroep.nl', 'OMROEP-CONTENT'],
    ['podcast.npo.nl', 'OMROEP-PODCAST'],
    ['video.omroep.nl', 'OMROEP-VIDEO'],
    ['download.omroep.nl', 'OMROEP-DOWNLOAD'],
    ['download.nos.nl', 'NOS'],
    ['entry.cdn.npoaudio.nl', 'NPOAUDIO']
];
export const npoCdnProviders = createImmutableMap(npoCdnProvidersData);
